import { render } from "./_courseTeachers.vue?vue&type=template&id=29019d3e"
import script from "./_courseTeachers.vue?vue&type=script&lang=js"
export * from "./_courseTeachers.vue?vue&type=script&lang=js"

import "./_courseTeachers.vue?vue&type=style&index=0&id=29019d3e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__